// src/components/EmpBrandLogo.js
import React from 'react';
import Box from '@mui/material/Box';

const BrandLogo = () => {
  return (
    <Box 
      component="a" 
      href="/" 
      className="medsai-header-logo"
      sx={{ 
        display: 'inline-flex', 
        alignItems: 'baseline', 
        textDecoration: 'none !important',
        color: 'inherit'
      }}
    >
      Meds
      <Box component="span" className="medsai-logo-ai-group">
        Ai
        <Box component="span" className="medsai-logo-tm">™</Box>
      </Box>
    </Box>
  );
};

export default BrandLogo;